// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__P8MI1","name":"styles_name__25YAf","phone":"styles_phone__2XJVj"};